import template from './sw-cms-block-text-teaser.html.twig';
import './sw-cms-block-text-teaser.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
